import { displayDate } from "~/plugins/functions/display";
import type { IModelPermissionResponse } from "./permission.dto";

export interface IModelRolesResponse {
  id: number;
  applicationId: number;
  name: string;
  status: string;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  application_id: number;
}

export class ModelRoles {
  id: number;
  applicationId: number;
  name: string;
  status: string;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  application_id: number;
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(props: IModelRolesResponse) {
    this.id = props.id;
    this.applicationId = props.applicationId;
    this.name = props.name;
    this.status = props.status;
    this.type = props.type;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.application_id = props.application_id;
    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayUpdatedAt = displayDate(this.updatedAt);
  }
}

export interface IRolePermissionRelation {
  id: number;
  roleId: number;
  permissionId: number;
  createdAt: string | Date;
  updatedAt: string | Date;
  action: string;
  permission: IModelPermissionResponse;
}

export interface IModelRoleDetailResponse {
  id: number;
  applicationId: number;
  name: string;
  status: string;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  application_id: number;
  rolePermissionRelations: IRolePermissionRelation[];
}

export class ModelRoleDetail {
  id: number;
  applicationId: number;
  name: string;
  status: string;
  type: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  application_id: number;
  permissionList: IRolePermissionRelation[];
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(props = {} as IModelRoleDetailResponse) {
    props = props ?? {};
    this.id = props.id || 0;
    this.applicationId = props.applicationId || 0;
    this.name = props.name || '';
    this.status = props.status || '';
    this.type = props.type || '';
    this.createdAt = props.createdAt || '';
    this.updatedAt = props.updatedAt || '';
    this.application_id = props.application_id || 0;
    this.permissionList = props.rolePermissionRelations || [];
    this.displayCreatedAt = displayDate(this.createdAt);
    this.displayUpdatedAt = displayDate(this.updatedAt);
  }
}


